import React from "react";
import {
  Modal as MantineModal,
  ModalProps as MantineModalProps,
  Box,
  BoxProps,
  Button,
} from "@mantine/core";
import cx from "clsx";
import styles from "@scss/custom-components/modal.module.scss";

/* ---------- Main component ---------- */

export interface CustomModalProps extends MantineModalProps {
  className?: string;
}

type ModalComponent = React.FC<CustomModalProps> & {
  Body: React.FC<CustomModalBodyProps>;
  Footer: React.FC<CustomModalFooterProps>;
};

export const CustomModal: ModalComponent = ({
  className,
  children,
  onClose,
  ...props
}) => (
  <MantineModal
    withCloseButton={false}
    onClose={onClose}
    classNames={{
      root: styles.modalRoot,
      inner: styles.inner,
      content: styles.modal,
      overlay: styles.overlay,
      body: styles.modalBody,
    }}
    {...props}
  >
    <Button variant="ghost" style={{ position: "absolute" }}></Button>

    {/* custom close icon shows only if onClose supplied */}
    {onClose && (
      <Button
        variant="ghost"
        size="sm"
        className={styles.close}
        rightSection={
          <></>
        }
        onClick={onClose}
        classNames={{ section: styles.closeSection }}
      >
        CLOSE
      </Button>
    )}

    {children}
  </MantineModal>
);

/* ---------- Sub-components ---------- */

export interface CustomModalBodyProps extends BoxProps {
  className?: string;
  children?: React.ReactNode;
}

const Body: React.FC<CustomModalBodyProps> = ({
  className,
  children,
  ...props
}) => (
  <Box component="section" className={cx(styles.body, className)} {...props}>
    {children}
  </Box>
);
Body.displayName = "CwiggoModal.Body";

export interface CustomModalFooterProps extends BoxProps {
  className?: string;
  children?: React.ReactNode;
}

const Footer: React.FC<CustomModalFooterProps> = ({
  className,
  children,
  ...props
}) => (
  <Box component="footer" className={cx(styles.footer, className)} {...props}>
    {children}
  </Box>
);
Footer.displayName = "CwiggoModal.Footer";

CustomModal.Body = Body;
CustomModal.Footer = Footer;
